/** Fire a transient toast. Empty / whitespace messages are ignored. */
export function toast(message: string, ms = 2500) {
  const text = (message || '').trim();
  if (!text) return;
  // Never announce empty loads
  if (/^loaded 0\b/i.test(text)) return;
  window.dispatchEvent(new CustomEvent('p1s-toast', { detail: { message: text, ms } }));
}
